import { SET_HASHED_CUSTOMER_ID } from './types';

export const setHashedCustomerId = (hashedCustomerId: string) => (dispatch: any) => {
  dispatch({
    type: SET_HASHED_CUSTOMER_ID,
    payload: hashedCustomerId,
  });
};
